// extracted by mini-css-extract-plugin
module.exports = {"container":"RandstadAppsDetails_container__1YLiI","appsContainer":"RandstadAppsDetails_appsContainer__3-uEy"};